import { ReactNode } from 'react';
import useAuthorityAll from 'hooks/useAuthorityAll';
import RoleGuard from './RoleGuard';

const ROLES = ['get_list'];
export default function AplusGuard({ children }: { children: ReactNode }) {
  const permission = useAuthorityAll({ ctrl: 'main_resource', role: ROLES });
  return (
    <RoleGuard ctrl="main_resource" role={ROLES} rolestring="get_list">
      {permission.get_list ? children : null}
    </RoleGuard>
  );
}
